// fr strings for messages/home.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const home: Dict = {
  "home.seo.title":
    "Jammable : covers IA, modificateur de voix IA et clonage de voix",
  "home.seo.description":
    "Plus de 100 000 voix IA de chanteurs, personnages et célébrités. Fais des covers IA, transforme ta voix ou clone la tienne. Écouter les voix est gratuit.",
  "home.seo.ogTitle":
    "Jammable : covers IA, modificateur de voix IA et clonage de voix",
  "home.seo.imageAlt": "Jammable : crée des covers IA",
  "home.hero.views":
    "Plus de 10 milliards de vues sur TikTok, YouTube et Instagram",
  "home.hero.titleBefore": "Crée des",
  "home.hero.titleHighlight": "covers IA",
  "home.hero.titleAfter": "avec tes voix préférées",
  "home.hero.subtitle":
    "Choisis parmi plus de 100 000 voix IA, ajoute ton audio et récupère ta cover en quelques secondes.",
  "home.hero.decorVoice": "Voix IA",
  "home.hero.decorCover": "cover",
  "home.hero.searchLabel": "Rechercher des voix",
  "home.hero.searchPlaceholder": "Cherche parmi plus de 100 000 voix",
  "home.hero.searchButton": "Rechercher",
  "home.hero.makeCover": "Faire une cover",
  "home.categories.all": "Voir toutes les catégories",
  "home.recent": "Reprends où tu en étais",
  "home.trending": "Tendances du moment",
  "home.seeAll": "Tout voir",
  "home.train.kicker": "Plus de 100 000 voix ont commencé comme ça",
  "home.train.titleBefore": "Entraîne ta propre",
  "home.train.titleHighlight": "voix IA",
  "home.train.body":
    "Crée une voix à partir de quelques extraits, puis fais des covers avec une voix que personne d'autre n'a.",
  "home.train.step1": "Importe tes extraits",
  "home.train.step1Sub": "Un court extrait de voix bien claire suffit",
  "home.train.step2": "On entraîne ton modèle",
  "home.train.step2Sub": "Ta voix perso est prête en quelques minutes",
  "home.train.step3": "Fais des covers avec",
  "home.train.step3Sub": "Utilise-la dans tes covers quand tu veux",
  "home.topCollections": "Meilleures collections",
  "home.collabs": "Collabs du moment",
  "home.collection": "Collection",
  "home.card.uses": "{n} utilisations",
  "home.card.voices": "{n} voix",
  "home.card.likes": "{n} j'aime",
  "home.card.by": "par @{user}",
  "home.card.madeToday": "{n} covers aujourd'hui",
  "home.card.makeDuet": "Faire ce duo",
  "home.discord.bannerSub":
    "Partage tes covers, demande des voix et fais-toi aider par la communauté",
  "home.discord.online": "{n} en ligne",
  "home.discord.members": "{n} membres",
  "home.discord.joinDiscord": "Rejoindre Discord",
  "home.discord.softSub":
    "Partage tes covers, demande des voix, récupère des astuces",
  "home.discord.cardSub":
    "Trouve de l'aide, partage tes covers, découvre de nouvelles voix",
  "home.discord.join": "Rejoindre",
};

export default home;
